"use client";

import Link from "next/link";
import type { ButtonProps } from "app/_components/components/Button";
import { Button } from "app/_components/components/Button";
import { usePathnameChecks } from "hooks/usePathnameChecks";

export function SignInLink({
  label,
  ...props
}: {
  label: string;
} & ButtonProps) {
  const { isGoogleSearchPath } = usePathnameChecks();

  if (isGoogleSearchPath) return null;

  return (
    <Button asChild id="header-signin" variant="tertiary" {...props}>
      <Link className="text-white" href="https://exchange.gemini.com/signin">
        {label}
      </Link>
    </Button>
  );
}
